import { forwardRef, useState, useImperativeHandle, ReactNode } from "react"
import Modal from "./Modal"
import Button from "./Button"

export type ConfirmModalRef = {
  open(options: ConfirmModalOptions): void
  close(): void
}

export type ConfirmModalOptions = {
  content: ReactNode
  onConfirm(): void
  onCancel?(): void
  confirmLabel?: ReactNode
  cancelLabel?: ReactNode
}

const ConfirmModal = forwardRef<ConfirmModalRef>((_, ref) => {
  const [options, setOptions] = useState<ConfirmModalOptions | null>(null)

  const open: ConfirmModalRef["open"] = (options) => {
    setOptions(options)
  }

  const close: ConfirmModalRef["close"] = () => {
    setOptions(null)
  }

  useImperativeHandle(ref, () => ({ open, close }))

  return (
    options !== null &&
    <Modal close={close}>
      {options.content}
      <div className={"w-full flex gap-x-2"}>
        <Button onClick={(): void => {
          close()
          options.onCancel && options.onCancel()
        }} className={"w-1/2"}>
          ANNULLA
        </Button>
        <Button onClick={(): void => {
          close()
          options.onConfirm()
        }} className={"w-1/2"}>
          CONFERMA
        </Button>
      </div>
    </Modal> || null
  )
})

ConfirmModal.displayName = "ConfirmModal"

export default ConfirmModal